import styles from '../RichTextEditor.module.scss';
import { Button } from 'antd';
import classNames from 'classnames';

export interface ToolbarButtonProps {
  icon?: React.ReactNode;
  onClick?: () => void;
  title?: string;
  disabled?: boolean;
  active?: boolean;
  visibleText?: string;
  className?: string;
}

export function ToolbarButton(props: ToolbarButtonProps) {
  const {
    icon,
    onClick,
    disabled = false,
    active = false,
    visibleText,
    className,
  } = props;
  return (
    <Button
      type="link"
      icon={icon}
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        styles.toolbarButton,
        active && styles.active,
        className,
      )}
    >
      {visibleText && (
        <span className={styles.ellipsisText}>{visibleText}</span>
      )}
    </Button>
  );
}
